// extracted by mini-css-extract-plugin
export var root = "Customer-module--root--6a0f4";